import flatMap from 'lodash/flatMap';
import * as React from 'react';
import isEqual from 'react-fast-compare';
import { connect } from 'react-redux';
import { closeApplyPromoCodeConfirmModal, closeCartRemovalModal, removeSeatFromCart } from '../../cart/actions/cart-actions';
import { ItemType } from '../../classes/item-type';
import { PriceType } from '../../classes/price-type';
import { Seat } from '../../classes/seat';
import { IOption, SeatingOptionGroup } from '../../classes/seating-option';
import { ZoneUpsell } from '../../classes/zone-upsell';
import DataLoader from '../../common/loader/data-loader';
import Modal from '../../common/modal/modal';
import ModalState from '../../common/modal/modal-states';
import Sidebar from '../../common/sidebar/sidebar';
import { selectPriceTypeTickets, setPriceRange } from '../../filter/actions/filter-actions';
import { selectMaxPrice, selectMinPrice } from '../../filter/actions/price-range-actions';
import { applyPromoCode } from '../../filter/actions/promo-actions';
import { convertNumberListToString } from '../../helpers/array-helpers';
import { CartHelpers } from '../../helpers/cart-helpers';
import isMobile from '../../helpers/is-mobile';
import { getSelectedPriceTypesFromFilter } from '../../helpers/price-type-helpers';
import { showLevelFilters, showPriceRangeFilters, showPriceTypeFilters, showSpecialSeatingFilters } from '../../helpers/state-helpers';
import { IAppState } from '../../reducers/index';
import { closeSeatingInfo, closeSeatmapCart, closeSeatmapFilters, openSeatingInfo, openSeatmapFilters, resetZoneUpsellCount } from '../../seatmap/actions/seatmap-actions';
import { hoverSeatCoordinates, unselectSeat } from '../actions/seatmap-actions';
import { fetchSeatMap } from '../actions/seatmap-fetch';
import CartOverlay from '../components/cart-panel/cart-overlay';
import FiltersOverlay from '../components/filter-panel/filters-overlay';
import Legend from '../components/legend';
import LegendModal from '../components/legend-modal';
import LevelSelectionModal from '../components/level-selection-modal';
import SvgMap from '../components/map';
import SvgMapHover from '../components/map-hover';
import SeatingInfoContainer from '../components/side-panel/seating-info-container';

interface ISeatMapState {
    middleCoordX: number;
    middleCoordY: number;
    newTop: number;
    newRight: number;
    showZoneUpsell: boolean;
    seatsToHideUpsell: Array<string>;
    legendFlyOut: boolean;
    selectedPriceTypeFilter: Array<PriceType>;
    selectedSpecialSeatingFilter: Array<SeatingOptionGroup>;
    mapDragging: boolean;
    hoveredSeatId: string;
    showLevelSelectFilter: boolean;
    levelSelectFilterOpen: boolean;
    showPriceRangeFilter: boolean;
    showPriceTypeFilter: boolean;
    priceTypeFilterOpen: boolean;
    showSpecialSeatingFilter: boolean;

    startingMin: number;
    startingMax: number;
    showLevelSelectModal: ModalState;
    cartDisabled: boolean;
};

enum SidebarItems {
    SeatInfo = 'seat-info',
    Cart = 'cart',
    Filters = 'filters'
}

class Seatmap extends React.Component<IAppState, ISeatMapState>{
    constructor(props: IAppState) {
        super(props);
        let seatMapTitle = document.getElementsByTagName('title')[0];

        if (!props.appSettingsModel.disableSmartSeatPageTitle) {
            seatMapTitle.innerHTML = `${props.appSettingsModel.itemName} | Select Your Seats`;
        }

        let selectedPriceTypesFromFilter = getSelectedPriceTypesFromFilter(props.priceTypesModel, props.appSettingsModel.selectAllPriceTypesOnSeatmap, (!props.appSettingsModel.selectAllPriceTypesOnSeatmap && props.appSettingsModel.selectOnlyDefaultPriceTypesOnSeatmap));
        let selectedSpecialSeatingFromFilter = this.getSelectedSpecialSeatingFromFilter(props);

        let showLevelSelectFilter = showLevelFilters(props.appSettingsModel);
        let showPriceRangeFilter = showPriceRangeFilters(props.priceRangeModel);
        let showPriceTypeFilter = showPriceTypeFilters(props.appSettingsModel);
        let showSpecialSeatingFilter = showSpecialSeatingFilters(props.appSettingsModel);

        if (!showPriceRangeFilter && !showPriceTypeFilter && !showLevelSelectFilter) {
            props.dispatch(closeSeatmapFilters(false));
        }

        let selectPriceTypeFilter = selectedPriceTypesFromFilter.length > 0 ? selectedPriceTypesFromFilter
            : props.priceTypesModel.priceTypes;

        this.state = {
            middleCoordX: null,
            middleCoordY: null,
            newTop: null,
            newRight: null,
            showZoneUpsell: true,
            seatsToHideUpsell: [],
            legendFlyOut: props.appSettingsModel.showSeatingLegendOnPageLoad,
            selectedPriceTypeFilter: selectPriceTypeFilter,
            selectedSpecialSeatingFilter: selectedSpecialSeatingFromFilter,
            mapDragging: false,
            hoveredSeatId: null,
            showLevelSelectFilter: showLevelSelectFilter,
            levelSelectFilterOpen: props.appSettingsModel.expandLevelFilterOnSeatmapLoad,
            showPriceRangeFilter: showPriceRangeFilter,
            showPriceTypeFilter: showPriceTypeFilter,
            showSpecialSeatingFilter: showSpecialSeatingFilter,
            priceTypeFilterOpen: true,
            startingMin: props.priceRangeModel.minPrice,
            startingMax: props.priceRangeModel.maxPrice,
            showLevelSelectModal: props.appSettingsModel.isSelectSeatVenue && props.appSettingsModel.displayLevelSelectionOnLoad ? ModalState.OPEN : ModalState.CLOSE,
            cartDisabled: false
        };
    }

    componentWillMount() {
        this.props.dispatch(unselectSeat());
        this.props.dispatch(fetchSeatMap('', this.props.cartModel.seats, false, []));
    }

    //getExchangePriceTypes(priceTypes: Array<PriceType>, activeExchangeTickets: Array<IExchangeTicket>): Array<PriceType> { 
    //    return priceTypes.map(pt => {
    //        pt.prices = pt.prices.map(pr => calculateExchangePrice(pr, activeExchangeTickets))
    //        return pt;
    //    });
    //}

    shouldComponentUpdate(nextProps, nextState: ISeatMapState) {
        if (this.state.mapDragging || nextState.mapDragging)
            return false;
        return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps);
    }

    zoomedStart = () => {
        this.setState({ ...this.state, mapDragging: true });
    };

    zoomedEnd = () => {
        this.setState({ ...this.state, mapDragging: false });
    };

    openLevelSelectModal = () => {
        this.setState({ ...this.state, showLevelSelectModal: ModalState.OPEN });
    }

    closeLevelSelectModal() {
        this.setState({ ...this.state, showLevelSelectModal: ModalState.CLOSE });
    }

    getSelectedSpecialSeatingFromFilter(props: IAppState): Array<SeatingOptionGroup> {
        return props.additionalSeatingOptionModel.additionalSeatingOptions.filter(option => option.groupSeatSelectedQuantity > 0);
    }

    getAvailablePriceTypesFromPricing(props: IAppState): Array<number> {
        return flatMap(props.seatMapModel.allSeatPricing, pr => pr.prices.map(price => price.priceTypeId));
    }

    componentWillReceiveProps(nextProps: IAppState) {

        var updatedShowZoneUpsell = this.state.showZoneUpsell;
        var updatedShowLevelSelectModal = this.state.showLevelSelectModal;
        var updatedSelectedPriceTypeFilter = this.state.selectedPriceTypeFilter;
        var choseNewSeats = !isEqual(this.props.seatMapModel.selectedSeats, nextProps.seatMapModel.selectedSeats);
        var needUpdate = false;

        if (choseNewSeats || !isEqual(this.props.seatMapModel.selectedPriceQuantities, nextProps.seatMapModel.selectedPriceQuantities)) {
            updatedShowZoneUpsell = true;
            needUpdate = true;
        }

        // If the modal is open
        if (this.state.showLevelSelectModal === ModalState.OPEN
            // And we already have a seatMapModel
            && this.props.seatMapModel.seatmapId
            // And it's changed
            && this.props.seatMapModel.seatmapId !== nextProps.seatMapModel.seatmapId) {

            // Time to close it
            updatedShowLevelSelectModal = ModalState.CLOSE
            needUpdate = true;
        }

        if (this.props.appSettingsModel.selectAllPriceTypesOnSeatmap != nextProps.appSettingsModel.selectAllPriceTypesOnSeatmap
            || !isEqual(nextProps.priceTypesModel.priceTypes, this.props.priceTypesModel.priceTypes)) {
            needUpdate = true;
            updatedSelectedPriceTypeFilter = this.updateSelectedPriceTypes(nextProps);
        }

        if (!isEqual(nextProps.seatMapModel.allSeatPricing, this.props.seatMapModel.allSeatPricing)) {
            var currentPricing = this.getAvailablePriceTypesFromPricing(nextProps);
            // if the selected price type filters have no matching price types in the current level, remove the filter
            if (this.props.seatMapModel.seatmapId !== "" && this.props.seatMapModel.seatmapId !== nextProps.seatMapModel.seatmapId
                && currentPricing.length > 0 && this.state.selectedPriceTypeFilter.every(ptFilter => currentPricing.indexOf(ptFilter.priceTypeId) < 0)) {
                needUpdate = true;
                updatedSelectedPriceTypeFilter = this.updateSelectedPriceTypes(nextProps);
            }
        }


        if (needUpdate) {
            this.setState({
                ...this.state,
                showZoneUpsell: updatedShowZoneUpsell,
                showLevelSelectModal: updatedShowLevelSelectModal,
                selectedPriceTypeFilter: updatedSelectedPriceTypeFilter,
                cartDisabled: CartHelpers.checkCartForMinQuantities(nextProps.cartModel.seats, nextProps.appSettingsModel.priceTypeSettings)
            });
        }
    }

    private updateSelectedPriceTypes(nextProps: IAppState): PriceType[] {
        let selectedPriceTypesFromFilter = getSelectedPriceTypesFromFilter(nextProps.priceTypesModel, nextProps.appSettingsModel.selectAllPriceTypesOnSeatmap, (!nextProps.appSettingsModel.selectAllPriceTypesOnSeatmap
            && nextProps.appSettingsModel.selectOnlyDefaultPriceTypesOnSeatmap));
        let selectPriceTypeFilter = selectedPriceTypesFromFilter.length > 0 ? selectedPriceTypesFromFilter
            : nextProps.priceTypesModel.priceTypes;
        return selectPriceTypeFilter;
    }

    private get isInCart(): boolean {
        if (this.props.cartModel.seats.length === 0)
            return false;
        else {
            var isInCart = this.props.cartModel.seats.filter(cartSeat => {
                return this.props.seatMapModel.selectedSeats
                    .some(seat => seat.seatId === cartSeat.seatId)
            }).length === 1;
            return isInCart;
        }
    }

    private get canChangeDate(): boolean {

        if (this.props.appSettingsModel.itemType === ItemType.Exchange || this.props.appSettingsModel.itemType === ItemType.Performance) {
            if (this.props.appSettingsModel.enableDateChange && this.props.appSettingsModel.productionPerformances.length > 1) {
                return true;
            }
        }

        return false;
    }

    _redirectOnFail() {
        window.location.href = this.props.appSettingsModel.seatmapLoadErrorRedirectUrl as any;
    }

    render() {
        const mobileCheck = isMobile();
        var seatInCartLoaded = this.isInCart;

        //need to partition this out to two checks, one to disabled one click and one to show upsell. plus this disable one click is wrong
        const zoneUpsellForSelectedSeats = this.props.seatMapModel.selectedSeats.length > 0 ? this.props.seatMapModel.zoneUpsells
            .filter(zoneUpsell => {
                return this.props.seatMapModel.selectedPriceQuantities.some(priceQuantity => priceQuantity.quantity > 0
                    && priceQuantity.seatPricing.zoneId === zoneUpsell.currentZoneId
                    && priceQuantity.seatPricing.priceTypeId === zoneUpsell.priceTypeId);
            })
            : [];

        var cart = document.getElementById('cartIcon');
        if (cart !== null) {
            if (seatInCartLoaded) {
                cart.classList.add('grow');
                var cartAmount = document.getElementById('cartAmountIcon');
                if (cartAmount != null) {
                    cartAmount.classList.add('show');
                }
            }
        }

        // Woah
        const hidingUpsell = !this.state.showZoneUpsell || (mobileCheck && !this.props.appSettingsModel.zoneUpsellEnableForMobile) || zoneUpsellForSelectedSeats.length == 0
            || this.props.seatMapModel.selectedSeats.some(selectedSeat =>
                this.props.cartModel.seats.some(cartSeat => cartSeat.seatId === selectedSeat.seatId))
            || this.state.seatsToHideUpsell.filter(seatId => this.props.seatMapModel.selectedSeats.filter(seat => seat.seatId === seatId).length > 0).length > 0
            || (this.props.appSettingsModel.zoneUpsellNumberOfTimesToUpsell > 0 ? this.props.seatMapModel.seatUpsoldCount >= this.props.appSettingsModel.zoneUpsellNumberOfTimesToUpsell : false);

        const visibleSidebar = this.props.seatMapModel.openSeatmapCart ? SidebarItems.Cart
            : this.props.seatMapModel.openSeatmapFilters ? SidebarItems.Filters
                : (!isMobile() && this.props.seatMapModel.openSeatingInfo ? SidebarItems.SeatInfo : undefined);

        const closeSidebar = () => {
            if (visibleSidebar) {
                if (visibleSidebar === SidebarItems.Cart) {
                    this.props.dispatch(closeSeatmapCart(false));
                }
                else if (visibleSidebar === SidebarItems.Filters) {
                    this.props.dispatch(closeSeatmapFilters(false));
                }
                else if (visibleSidebar === SidebarItems.SeatInfo) {
                    this.props.dispatch(closeSeatingInfo());
                }
            }
        }

        return (
            <main className={"seatmap-container" + (this.props.seatMapModel.selectedSeats.length > 0 ? " show-seat-view" : "") + (this.props.applicationModel.viewFromSeatModalActive ? " show-seat-modal-view" : "") + (this.props.seatMapModel.openSeatingInfo ? " show-seat-info-view" : "")}>
                {
                    this.state.showLevelSelectModal == ModalState.OPEN ?
                        <LevelSelectionModal modalKey="Level Select seat map modal"
                            cancelFunction={this.closeLevelSelectModal.bind(this)}
                            cancelString="caneldar"
                            closeFunction={this.closeLevelSelectModal.bind(this)}
                            confirmFunction={null}
                            confirmString="adsf"
                            isError={false}
                            key="Level Select seat map modal"
                            message="adsf"
                            showModal={true}
                            title="adsf"
                            levelHeading={this.props.appSettingsModel.levelsHeading}
                            modalClass="levelselection-modal"
                            //level select props
                            currentSeatmapId={this.props.seatMapModel.seatmapId}
                            cartSeats={this.props.cartModel.seats}
                            appSettings={this.props.appSettingsModel}
                            dispatch={this.props.dispatch}
                            venueLevels={this.props.venueLevelModel.venueLevels}
                            selectedPriceTypeIdsString={convertNumberListToString(this.props.priceTypesModel.priceTypes.filter(pt => pt.selectedQuantity > 0).map(pt => pt.priceTypeId))}
                        />
                        : null
                }

                {
                    this.props.cartModel.showApplyPromoConfirmModal ?
                        <Modal cancelFunction={this._closeApplyPromoConfirmModal}
                            cancelString={this.props.appSettingsModel.promoCodeConfirmApplyCancel}
                            closeFunction={this._closeApplyPromoConfirmModal}
                            confirmFunction={this._confirmApplyPromoConfirmModal}
                            confirmString={this.props.appSettingsModel.promoCodeConfirmApplyConfirm}
                            isError={false}
                            key="Apply Promo Confirm Modal"
                            message={this.props.appSettingsModel.promoCodeConfirmApplyMessage}
                            modalKey="Cart Removal Confirm Prompt"
                            title={this.props.appSettingsModel.promoCodeConfirmApplyTitle} /> : null
                }

                {
                    this.props.cartModel.showCartRemovalConfirmPrompt ?
                        <Modal cancelFunction={this._closeCartRemovalConfirmModal}
                            cancelString={this.props.appSettingsModel.modalCancelButtonText}
                            closeFunction={this._closeCartRemovalConfirmModal}
                            confirmFunction={this._confirmCartRemovalConfirmModal}
                            confirmString={this.props.appSettingsModel.modalConfirmButtonText}
                            isError={false}
                            key="Cart Removal Confirm Prompt"
                            message={this.props.appSettingsModel.specialSeatingRemovalConfirmPromptMessage}
                            modalKey="Cart Removal Confirm Prompt"
                            title={this.props.appSettingsModel.specialSeatingRemovalConfirmPromptHeader} /> : null
                }
                {
                    this.props.errorModel.getSeatmapFailed ?
                        <Modal modalKey="seat map load" isError={true}
                            message={this.props.appSettingsModel.seatmapLoadErrorMessage}
                            title={this.props.appSettingsModel.seatmapLoadErrorTitle}
                            confirmFunction={this._redirectOnFail.bind(this)}
                            confirmString={this.props.appSettingsModel.seatmapLoadErrorBackButton}
                            closeFunction={this._redirectOnFail.bind(this)}
                        />
                        :
                        !this.props.seatMapResultModel.requestingBackgroundPaths
                            && !this.props.seatMapResultModel.requestingSeatmap
                            && !this.props.seatMapResultModel.requestingSeatPaths
                            ?

                            <div className={"seatmap-content" + (!hidingUpsell ? " show-upsell" : "")}>

                                {
                                    this.props.appSettingsModel.showSeatingLegendAsModal ?
                                        <LegendModal seatStyles={this.props.seatMapModel.seatStyles} seatStyleCultures={this.props.seatMapModel.seatStyleCultures}
                                            selectedSeats={this.props.seatMapModel.selectedSeats.length > 0}
                                            isMobile={mobileCheck}
                                            legendFlyOut={this.state.legendFlyOut && this.state.showLevelSelectModal !== ModalState.OPEN}
                                            legendTitle={this.props.appSettingsModel.legendText}
                                            legendTitleAltText={this.props.appSettingsModel.altText !== null ? this.props.appSettingsModel.altText.legendIcon : ''}
                                            updateLegendFlyout={this._updateLegendFlyoutState}
                                            legendModalText={this.props.appSettingsModel.legendModalText}
                                        />
                                        :
                                        <Legend seatStyles={this.props.seatMapModel.seatStyles} seatStyleCultures={this.props.seatMapModel.seatStyleCultures}
                                            selectedSeats={this.props.seatMapModel.selectedSeats.length > 0}
                                            isMobile={mobileCheck}
                                            legendFlyOut={this.state.legendFlyOut && this.state.showLevelSelectModal !== ModalState.OPEN}
                                            legendTitle={this.props.appSettingsModel.legendText}
                                            legendTitleAltText={this.props.appSettingsModel.altText !== null ? this.props.appSettingsModel.altText.legendIcon : ''}
                                            updateLegendFlyout={this._updateLegendFlyoutState}
                                            legendModalText={this.props.appSettingsModel.legendModalText}
                                        />
                                }

                                <div className="seatmap-content-map" onTouchMove={function (evt) { evt.preventDefault(); }}>
                                    <SvgMap backgroundImageElement={this.props.seatMapModel.levelSvgBackgroundImage} seats={this.props.seatMapModel.levelSeats}
                                        selectedSeats={this.props.seatMapModel.selectedSeats}
                                        appSettings={this.props.appSettingsModel}
                                        seatMapModel={this.props.seatMapModel}
                                        dispatch={this.props.dispatch}
                                        cartSeats={this.props.cartModel.seats}
                                        priceRangeModel={this.props.priceRangeModel}
                                        backgroundPaths={this.props.seatMapModel.levelBackgroundPaths}
                                        selectedPriceTypeFilter={this.state.selectedPriceTypeFilter}
                                        selectedSpecialSeatingFilter={this.state.selectedSpecialSeatingFilter}
                                        mapDragging={this.state.mapDragging}
                                        mapStartDragging={this.zoomedStart}
                                        hoveredSeatId={this.state.hoveredSeatId}
                                        mapEndDragging={this.zoomedEnd}
                                        mouseOutSeat={this._mouseOutSeat}
                                        mouseOverSeat={this._mouseOverSeat}
                                        showChangeLevelButton={showLevelFilters(this.props.appSettingsModel)}
                                        onChangeLevelClick={this._changeLevelButtonClick}
                                        isSeatmapView={this.props.location.pathname === "/seatmap" ? true : false}
                                        overlayOpen={visibleSidebar !== undefined}
                                        filterPanelOpen={visibleSidebar === SidebarItems.Filters}
                                        onNoSelectedPricesForSeatClick={this._noSelectedPriceSeatClick.bind(this)}
                                    />
                                </div>
                                {
                                    isMobile() ? null :
                                        (!this.state.mapDragging && this.props.seatMapModel.seatHoverX !== null && this.props.seatMapModel.seatHoverY !== null ?

                                            <div className="seatmap-hover" style={{ top: this.props.seatMapModel.seatHoverY, left: this.props.seatMapModel.seatHoverX, marginTop: '-40px' }}>
                                                <SvgMapHover
                                                    appSettings={this.props.appSettingsModel}
                                                    seatMapModel={this.props.seatMapModel}
                                                    dispatch={this.props.dispatch}
                                                    cartSeats={this.props.cartModel.seats}
                                                    selectedPriceTypeFilter={this.state.selectedPriceTypeFilter}
                                                    mapDragging={this.state.mapDragging}
                                                />
                                            </div>

                                            : null)
                                }

                                {
                                    isMobile() ?
                                        <>
                                            <Sidebar visibleChildKey={visibleSidebar} closeOverlays={closeSidebar.bind(this)} isMobile={true}>
                                                {this.renderFilters(hidingUpsell, zoneUpsellForSelectedSeats)}
                                                {this.renderCart(hidingUpsell)}
                                            </Sidebar>

                                            {this.renderSeatingInfo(hidingUpsell, zoneUpsellForSelectedSeats)}
                                        </>
                                        :
                                        <Sidebar visibleChildKey={visibleSidebar} closeOverlays={closeSidebar.bind(this)} isMobile={false}>
                                            {this.renderSeatingInfo(hidingUpsell, zoneUpsellForSelectedSeats)}
                                            {this.renderFilters(hidingUpsell, zoneUpsellForSelectedSeats)}
                                            {this.renderCart(hidingUpsell)}
                                        </Sidebar>
                                }


                            </div>
                            : <DataLoader loadingSvgText={this.props.appSettingsModel.loadingSvgText}
                                loadingText={this.props.appSettingsModel.loadingText}
                                stopAnimationText={this.props.appSettingsModel.stopLoadingAnimationButtonText} />
                }
            </main>

        );
    }

    private toggleSeatingInfo = () => {
        this.props.seatMapModel.openSeatingInfo ? this.props.dispatch(closeSeatingInfo()) : this.props.dispatch(openSeatingInfo());

    }

    private closeOverlays = () => {
        this.props.dispatch(closeSeatingInfo());
    }

    private renderSeatingInfo = (hidingUpsell: boolean, zoneUpsellForSelectedSeats: ZoneUpsell[]) => {
        if (this.props.seatMapModel.selectedSeats.length < 1) {
            return null;
        }

        const isGAZone = (this.props.seatMapModel.selectedSeats.length > 1);

        return (
            <SeatingInfoContainer
                key={SidebarItems.SeatInfo}
                viewFromSeatModalActive={this.props.applicationModel.viewFromSeatModalActive}
                activeSeats={this.props.seatMapModel.selectedSeats}
                levelPricing={this.props.seatMapModel.allSeatPricing}
                selectedPriceTypes={this.state.selectedPriceTypeFilter}
                appSettingsModel={this.props.appSettingsModel}
                cartSeats={this.props.cartModel.seats}
                cartUpdated={this.props.cartModel.cartUpdated}
                dispatch={this.props.dispatch}
                seatmapModel={this.props.seatMapModel}
                additionalSeatingOptionModel={this.props.additionalSeatingOptionModel}
                maxQuantityPriceTypeError={this.props.cartModel.maxPriceTypeTicketQuantityReached}
                flexQuantityPriceTypeError={this.props.cartModel.flexTicketQuantityNotReachedError}
                isGAZone={isGAZone}
                exchangeModel={this.props.exchangeSettingsModel}
                zoneUpsell={zoneUpsellForSelectedSeats[0]}
                seats={this.props.seatMapModel.levelSeats}
                onCloseZoneUpsell={this._onCloseZoneUpsell.bind(this)}
                onToggleSeatingInfoOpen={this.toggleSeatingInfo.bind(this)}
                selectedPriceTypeQuantities={this.props.seatMapModel.selectedPriceQuantities}
                hidingUpsell={hidingUpsell || isGAZone}
                maxQuantitySeatingOptionError={this.props.cartModel.maxSeatingOptionTicketQuantityReached}
                flexMinQuantityError={
                    this.props.cartModel.flexMinQuantityReachedForPriceType != null
                        && this.props.cartModel.quantityHasBeenModified
                }
                quantityHasBeenModified={this.props.cartModel.quantityHasBeenModified}
                flexMaxQuantityErrorAllTickets={this.props.cartModel.flexMaxQuantityReached}
                flexMaxQuantityErrorPriceType={this.props.cartModel.flexMaxQuantityReachedForPriceType}
                showSeatingInfo={this.props.seatMapModel.openSeatingInfo}
                showOverlay={this.props.seatMapModel.openSeatingInfo}
                closeOverlays={this.closeOverlays.bind(this)}
            //disableOnClickOutside={!isMobile()}
            //outsideClickIgnoreClass="seat-path"
            />
        );
    }

    private renderFilters = (hidingUpsell: boolean, zoneUpsellForSelectedSeats: ZoneUpsell[]) => {

        return (
            <React.Fragment key={SidebarItems.Filters} >
                <div className="overlay-section-mobile-background" onClick={() => this.props.dispatch(closeSeatmapFilters(false))}></div>
                <FiltersOverlay {...this.props.appSettingsModel}
                    priceRangeModel={this.props.priceRangeModel}
                    onSelectMaxPrice={this.onSelectMaxPrice}
                    onSelectMinPrice={this.onSelectMinPrice}
                    onPriceRangeClear={null}
                    startingMaxPrice={this.state.startingMax}
                    startingMinPrice={this.state.startingMin}
                    appSettings={this.props.appSettingsModel}
                    showComponent={this.props.seatMapModel.openSeatmapFilters}
                    onPriceTypeToggle={this.onTogglePriceType}
                    onLevelSelectOpenToggle={this._toggleLevelSelectFilter.bind(this)}
                    priceTypes={this.props.priceTypesModel.priceTypes.filter(ptS => this.getAvailablePriceTypesFromPricing(this.props).indexOf(ptS.priceTypeId) >= 0)}
                    selectedPriceTypes={this.state.selectedPriceTypeFilter}
                    activeExchangeTickets={this.props.exchangeSettingsModel.activeExchangeTickets}
                    showLevelSelectFilter={this.state.showLevelSelectFilter}
                    levelSelectFilterOpen={this.state.levelSelectFilterOpen}
                    showPriceRangeFilter={this.state.showPriceRangeFilter}
                    showPriceTypeFilter={this.state.showPriceTypeFilter}
                    onPriceTypeFilterOpenToggle={this._togglePriceTypeFilter}
                    openPriceTypeFilter={this.state.priceTypeFilterOpen}
                    dispatch={this.props.dispatch}
                    levels={this.props.venueLevelModel.venueLevels}
                    cartSeats={this.props.cartModel.seats}
                    currentSeatmapId={this.props.seatMapModel.seatmapId}
                    onLevelSelectModalOpen={this.openLevelSelectModal.bind(this)}
                    seatmapFiltersIsOpen={this.props.seatMapModel.openSeatmapFilters}
                    seatmapFiltersText={this.props.appSettingsModel.seatmapFiltersText}
                    showPerformanceSelectFilter={this.canChangeDate}
                    showSpecialSeatingFilter={this.state.showSpecialSeatingFilter}
                    additionalSeatingOptions={this.props.additionalSeatingOptionModel.additionalSeatingOptions.filter(option => option.seatConditionId)}
                    onSpecialSeatingToggle={this.onToggleSpecialSeating}
                    selectedSeatingOptions={this.state.selectedSpecialSeatingFilter}
                //disableOnClickOutside={!isMobile()}
                //outsideClickIgnoreClass="seat-path"
                />


                {
                    this.props.seatMapModel.selectedSeats.length === 0 ?
                        <div className="seat-info-container"></div>
                        : ""
                }

            </React.Fragment>
        )
    }

    private renderCart = (hidingUpsell: boolean) => {
        return (
            <React.Fragment key={SidebarItems.Cart} >
                <div className="overlay-section-mobile-background" onClick={() => this.props.dispatch(closeSeatmapCart(false))}></div>
                <CartOverlay
                    key={SidebarItems.Cart}
                    isMobile={isMobile()}
                    hidingUpsell={hidingUpsell}
                    showOverlay={this.props.seatMapModel.openSeatmapCart}
                    showPromoCode={this.props.appSettingsModel.enablePromoCodes}
                    promoCodeTitle={this.props.appSettingsModel.promoCodeTitle}
                    appSettings={this.props.appSettingsModel}
                    cartModel={this.props.cartModel}
                    cartOverlayMessage="NEED TO ADD TO VENUE BUILDER"
                    additionalNotesTitle={this.props.appSettingsModel.additionalNotesTitle}
                    dispatch={this.props.dispatch}
                    itemType={this.props.appSettingsModel.itemType}
                    promoCodeModel={this.props.promoCodeModel}
                    levelSeats={this.props.seatMapModel.levelSeats}
                    seatmapId={this.props.seatMapModel.seatmapId}
                    selectedSeats={this.props.seatMapModel.selectedSeats}
                    additionalSeatingOptionModel={this.props.additionalSeatingOptionModel}
                    seatmapCartText={this.props.appSettingsModel.cartTitle}
                    selectedPriceTypes={this.state.selectedPriceTypeFilter}
                    fetchSeatViewImage={this.props.seatMapModel.hasSeatViewImages}
                />
            </React.Fragment>

        )
    }

    private _onCloseZoneUpsell() {
        this.setState({
            ...this.state,
            showZoneUpsell: false,
            seatsToHideUpsell: this.state.seatsToHideUpsell.concat(this.props.seatMapModel.selectedSeats.map(seat => seat.seatId))
        })

        if (this.props.seatMapModel.seatUpsoldCount > 0) {
            this.props.dispatch(resetZoneUpsellCount);
        }
    }

    _closeApplyPromoConfirmModal = () => {
        this.props.dispatch(closeApplyPromoCodeConfirmModal());
    }

    _confirmApplyPromoConfirmModal = () => {
        this.props.dispatch(applyPromoCode(this.props.cartModel.promoCodeToApply,
            this.props.appSettingsModel.currentCulture,
            true, this.props.appSettingsModel.itemId, this.props.appSettingsModel.itemType));
        this.props.dispatch(closeApplyPromoCodeConfirmModal());
        this.props.dispatch(unselectSeat());
    }

    _closeCartRemovalConfirmModal = () => {
        this.props.dispatch(closeCartRemovalModal());
    }

    _confirmCartRemovalConfirmModal = () => {
        this.props.dispatch(removeSeatFromCart(this.props.cartModel.seatToRemove, this.state.selectedPriceTypeFilter, this.props.appSettingsModel.brandId, true));
        this.props.dispatch(closeCartRemovalModal());
    }

    private onSelectMinPrice = (minPrice: number) => {
        this.props.dispatch(selectMinPrice(minPrice))
    };

    private onSelectMaxPrice = (maxPrice: number) => {
        this.props.dispatch(selectMaxPrice(maxPrice))
    };

    private onTogglePriceType = (selectedOptions: IOption[]) => {
        var newPriceTypes = selectedOptions.map(option =>
            this.props.priceTypesModel.priceTypes
                .filter(pt => pt.priceTypeId.toString() === option.id)[0]);

        this.setState({
            ...this.state,
            selectedPriceTypeFilter: newPriceTypes
        });

        this.props.dispatch(setPriceRange(true, [], newPriceTypes));
    }

    private onToggleSpecialSeating = (selectedOptions: IOption[]) => {
        var newSpecialSeating = selectedOptions.map(option =>
            this.props.additionalSeatingOptionModel.additionalSeatingOptions
                .filter(specialSeating => specialSeating.id === option.id)[0]);

        this.setState({
            ...this.state,
            selectedSpecialSeatingFilter: newSpecialSeating
        })
    }

    private _toggleLevelSelectFilter = () => {
        this.setState({
            levelSelectFilterOpen: !this.state.levelSelectFilterOpen
        })
    }

    private _togglePriceTypeFilter = () => {
        this.setState({
            priceTypeFilterOpen: !this.state.priceTypeFilterOpen
        })
    }

    private _changeLevelButtonClick = () => {
        this.props.dispatch(openSeatmapFilters());
        this.setState({
            levelSelectFilterOpen: true
        })
    }

    // this is used when there is no pricing on a seat that has been clicked on
    private _noSelectedPriceSeatClick = () => {
        this.props.dispatch(openSeatmapFilters());
        this.setState({
            priceTypeFilterOpen: true,
            levelSelectFilterOpen: false
        })
    }

    private _mouseOverSeat = (seats: Array<Seat>, xPos: number, yPos: number) => {
        if (!this.state.hoveredSeatId !== null) {
            //let closeToCenter = Math.abs(window.innerHeight / 2 - yPos - 82) <= 100;
            //console.log(yPos);
            //console.log(closeToCenter);
            this.props.dispatch(hoverSeatCoordinates(xPos + 10, yPos - (window.innerHeight / 2 - yPos < -200 ? 200 : 20), seats))
            this.setState({ hoveredSeatId: seats[0].seatId });
        }
        //+ (window.innerHeight / 2 - yPos > 0 ? (closeToCenter ? 5 : 10) : (closeToCenter ? 5 : -20))
        //var yPos = this.computeSeatHoverPositionY(seat);
        //var xPos = this.computeSeatHoverPositionX(seat);



    }

    private _mouseOutSeat = () => {
        this.props.dispatch(hoverSeatCoordinates(null, null, []));
        this.setState({ hoveredSeatId: null });
    }

    _updateLegendFlyoutState = (flyoutStatus: boolean) => {
        this.setState({
            legendFlyOut: flyoutStatus
        });
    };

}

export default connect((state) => state)(Seatmap);